import { DOCUMENT, inject, Injectable, RendererFactory2 } from '@angular/core'

@Injectable()
export class EasterEggService {
  readonly renderer2 = inject(RendererFactory2).createRenderer(null, null)
  private readonly document = inject(DOCUMENT)

  activate() {
    this.document.documentElement.classList.add('rainbow-mode')
  }

  enableSailor() {
    this.renderer2.addClass(this.document.body, 'sailor')
  }
  disableSailor() {
    this.renderer2.removeClass(this.document.body, 'sailor')
  }
}
